import React, { createContext, Dispatch, ReactNode, useContext, useEffect, useReducer, useState } from "react";
import { validateToken } from "../loaders/auth-loaders";
import { setToken } from "../loaders/basic-loader";
import { FullPageLoader } from "../loaders/FullPageLoader";
import { User } from "../models/User";
import { Login } from "./Login";

export interface AuthAction {
    type: "setUser";
    payload?: any
}

export interface AuthContextState {
    user?: User
    dispatch?:Dispatch<AuthAction>
}

export function reducer(state: AuthContextState, action: AuthAction):AuthContextState{
    switch(action.type){
        case "setUser": return {...state, user: action.payload}
        default: return state
    }
}

export const AuthContext = createContext<AuthContextState>({});

export function AuthStore({children}:{children: ReactNode}){
    const [state, dispatch] = useReducer(reducer, {});
    const [validatingToken, setValidatingToken] = useState(true);

    useEffect(function(){
        (async function() {
            var token = localStorage.getItem("token");
            if(token){
                try{
                    const user = await validateToken(token);
                    setToken(user.token);
                    dispatch({type:"setUser", payload: user});
                } catch(ex){
                    console.log(ex);
                }
                
            }
            setValidatingToken(false);
        })()
    }, []);

    if(validatingToken)
        return <FullPageLoader />

    return <AuthContext.Provider value={{...state, dispatch}}>
        {state.user ? children : <Login dispatch={dispatch} />}
    </AuthContext.Provider>
}

export function useIsGuest(){
    const user = useContext(AuthContext).user
    if(!user) return false;
    return !user.isAdmin  && !user.isManager
}

export function useIsAwr(){
    return location.host.match(/awr/)
}